import React from 'react';
import ReviewCard from '../Hub/ReviewCard';

/**
 * Widget wrapper for ReviewCard
 * Shows pending facts and aliases for review
 */
export default function ReviewWidget({ 
  pendingFactsCount = 0, 
  pendingAliasesCount = 0,
  onOpenReviewModal,
  onReviewChanged
}) {
  return (
    <ReviewCard
      pendingFactsCount={pendingFactsCount}
      pendingAliasesCount={pendingAliasesCount}
      onOpenReviewModal={onOpenReviewModal}
      onReviewChanged={onReviewChanged}
    />
  );
}
